<template>
  <vx-card no-shadow>
    <div class="flex flex-wrap justify-between items-center mb-8">
       <vs-row class="mt-3">
        <vs-col vs-type="flex" vs-justify="start" vs-align="start" vs-w="12">
          <h3>Conexión a Zoom Meetings</h3>
          <img src="@/assets/images/logo/zoom.png" class="ml-5" alt="Zoom" style="width: 130px;">
        </vs-col>
      </vs-row>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <h5>
            <feather-icon icon="KeyIcon" class="w-5 h-5 mt-1"></feather-icon>
            Llave de Acceso
          </h5>
        </vs-col>
      </vs-row>
      <vs-row class="mt-3">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-input class="w-2/3" label="Zoom JWT" :disabled="existing" placeholder="Zoom JWT" v-model="zoomJWT"/>
        </vs-col>
      </vs-row>
      <vs-row class="mt-5">
        <vs-col v-if="invalid" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <p  class="text-danger">Por favor introduce un JWT válido para continuar.</p>
        </vs-col>
      </vs-row>
      <vs-row class="mt-5">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <h5>
            <feather-icon icon="MailIcon" class="w-5 h-5 mt-1"></feather-icon>
            Correo de la Cuenta:
          </h5>
        </vs-col>
      </vs-row>
      <vs-row class="mt-1">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-input
              v-validate="'required|email|min:3'"
              :disabled="existing"
              data-vv-validate-on="blur"
              name="email"
              icon-no-border
              icon="icon icon-user"
              icon-pack="feather"
              label-placeholder="Correo"
              v-model="zoomEmail"
              class="w-1/2 mt-3"/>
          
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span class="text-danger text-sm">{{ errors.first('email') }}</span>
        </vs-col>
      </vs-row>
      <vs-row class="mt-5">
        <vs-col v-if="!invalid && !existing && !errors.first('email')" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button color="success" type="filled" @click="addZoom">Guardar</vs-button>
        </vs-col>
        <vs-col v-if="existing" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button color="warning" type="filled" @click="existing = !existing">Editar</vs-button>
        </vs-col>
      </vs-row>
      <vs-divider class="mt-6"></vs-divider>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <vs-collapse class="w-full">
            <vs-collapse-item>
              <div slot="header">
                ¿Cómo Generar mi token JWT de Zoom?
              </div>
              <vs-row >
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                  <h5>1) Iniciar sesión en Zoom</h5>
                  <vs-button class="ml-2" size="small" color="primary" type="filled" icon="link" @click="goZM(1)">Iniciar Sesión</vs-button>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <img src="@/assets/images/tutorials/zoom1.png" alt="" style="max-width: 240px;">
                </vs-col>
              </vs-row>
              <vs-row class="mb-6 mt-6">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                  <h5>2) Visitar la sección de desarrollo de Zoom</h5>
                  <vs-button class="ml-2" size="small" color="primary" type="filled" icon="link" @click="goZM(2)">Ir a la sección de desarrollo</vs-button>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <img src="@/assets/images/tutorials/zoom7.jpg" alt="" style="max-width: 400px;">
                </vs-col>
              </vs-row>
              <vs-row class="mb-6 mt-6">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                  <h5>3) Navegar a la sección de registro de aplicaciones</h5>
                  <vs-button class="ml-2" size="small" color="primary" type="filled" icon="link" @click="goZM(3)">Visitar Registro de Aplicaciones</vs-button>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <img src="@/assets/images/tutorials/zoom2.jpg" alt="" style="max-width: 450px;">
                </vs-col>
              </vs-row>
              <vs-row class="mb-6 mt-6">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                  <h5>4) Completar la información de Evolugy</h5>
                  <vs-button class="ml-2" size="small" color="primary" type="filled" icon="link" @click="goZM(4)">Ver mis Apps de Zoom</vs-button>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-type="" vs-w="12">
                    <vs-list>
                      <vs-list-item title="Nombre" subtitle="Evolugy"></vs-list-item>
                      <vs-list-item title="Descripción" subtitle="Calendar for healthcare providers"></vs-list-item>
                      <vs-list-item title="Contacto del Desarrollador" subtitle="Nombre: Mayfer, Correo: backend@mayfer.dev"></vs-list-item>
                      <vs-list-item title="Links" subtitle="https://app.evolugy.com/pages/terms"></vs-list-item>
                    </vs-list>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col class="mt-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <img src="@/assets/images/tutorials/zoom3.png" alt="" style="max-width: 450px;">
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <img src="@/assets/images/tutorials/zoom4.png" alt="" style="max-width: 450px;">
                </vs-col>
              </vs-row>
              <vs-row class="mb-6 mt-6">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                  <h5>5) Generar Token JWT por el tiempo deseado.</h5>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-type="" vs-w="12">
                    <vs-list>
                      <vs-list-item title="Tiempo de Expliración" subtitle="Establecer un tiempo mayor a 1 año para evitar tener que cambiar el código frecuentemente.">
                      </vs-list-item>
                      <vs-list-item subtitle="Utilizar el formato: hh:mm MM/DD/YYYY">
                      </vs-list-item>
                    </vs-list>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col class="mt-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <img src="@/assets/images/tutorials/zoom5.png" alt="" style="max-width: 450px;">
                </vs-col>
              </vs-row>
              <vs-row class="mb-6 mt-6">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                  <h5>6) Copiar Token y guardar en la sección de ajustes: conexiones.</h5>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col class="mt-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <img src="@/assets/images/tutorials/zoom6.jpg" alt="" style="max-width: 450px;">
                </vs-col>
              </vs-row>
            </vs-collapse-item>
            <vs-collapse-item>
              <div slot="header">
                ¿Qué es un token JWT de Zoom?
              </div>
              El API de Zoom utiliza JSON Web Tokens (JWT) para autenticar el acceso a nivel de cuenta. <br>
              Estos tokens ofrecen un método para establecer una autenticación segura de servidor a servidor mediante la transferencia datos compactos
               protegidos por una firma digital de la clave y el secreto del API de su cuenta.
            </vs-collapse-item>
          </vs-collapse>
        </vs-col>
      </vs-row>

      <!-- <div>
        <a :href="zoomURL" target="_blank" rel="noopener noreferrer"><img src="https://marketplacecontent.zoom.us/zoom_marketplace/img/add_to_zoom.png" height="32" alt="Add to ZOOM" /></a>
        <vs-button type="border" color="danger" v-if="false">Desconectar</vs-button>
      </div>
      -->
    </div>
      
  </vx-card>
</template>

<script>
export default {
  data () {
    return {
      userData: {},
      evolugyUser: {},
      invalid: true,
      existing: false,
      zoomJWT: null,
      zoomEmail: null,
      zoomURL: 'https://zoom.us/oauth/authorize?response_type=code&client_id=BOg4tcdKTFnPz9O1cHoA&redirect_uri=https://app.evolugy.com/auth/zoom-redirect',
      old_password: '',
      new_password: '',
      confirm_new_password: ''
    }
  },
  computed: {
    // activeUserInfo () {
    //   return this.$store.state.AppActiveUser
    // }
    findZoomClinicsActive(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )
      });
      console.log(zoomClinics);
      return zoomClinics
    },
  },
  beforeCreate(){
     this.$store.dispatch('fetchClinics').then(response=>{
      // console.log('clinics: ', response);
    }, error => {
      console.error(error);
    });

  },
  created (){
    console.log('USER: ',this.$store.state.AppActiveUser);

    console.log('zoomC: ', this.findZoomClinicsActive);

    this.userData = JSON.parse(JSON.stringify(this.$store.state.AppActiveUser))
    if(this.userData.meta.zoom_jwt){
      this.zoomJWT = this.userData.meta.zoom_jwt;
      this.zoomEmail = this.userData.meta.zoom_email;
      this.existing = true;
    } else {
      this.existing = false;
    }
    
    this.evolugyUser = JSON.parse(window.localStorage.getItem('userInfo'));
  },
  methods: {
    goZM(url){
      var goURL = "";
      switch (url) {
        case 1:
          goURL = "https://zoom.us/signin"    
          break;
        case 2:
          goURL = "https://marketplace.zoom.us/"    
          break;
        case 3:
          goURL = "https://marketplace.zoom.us/develop/create"    
          break; 
        case 4:
          goURL = "https://marketplace.zoom.us/user/build"    
          break; 
      
        default:
          goURL = "https://zoom.us/signin" 
          break;
      }
      window.open(goURL, '_blank');
    },
    addZoom(){
      const metaUpdateUser = {
        id: this.userData.id,
        meta: {...this.userData.meta, ...{'zoom_jwt': this.zoomJWT, 'zoom_email': this.zoomEmail}}
      };
      this.$store.dispatch('evolugy/updateUser', metaUpdateUser);
      
      if(this.findZoomClinicsActive.length == 0){
        this.addNewClinic();
      }  else {
        console.log('already has zoom.')
      }
      
      this.showAlert(
            "success",
            "Acceso de Zoom Agregado",
            "Acceso de Zoom Agregado éxitosamente!"
          );
      this.existing = true;
    },
    addNewClinic(){
      
      let newClinicObj = new Object();
      newClinicObj.address = 'Zoom.us',
      newClinicObj.address_2 = 'Clinica Virtual',
      newClinicObj.phone = this.userData.phone ? this.userData.phone : [],
      // newClinicObj.city = this.newClinic.city,
      // newClinicObj.zone = this.newClinic.zone,
      // newClinicObj.country = this.newClinic.country.name,
      newClinicObj.title = 'Clinica Virtual',
      // newClinicObj.notes = this.newClinic.notes,
      newClinicObj.meta = {"type": "Virtual" , "zoom_active":"true"};

      this.$store.dispatch('addClinic',newClinicObj).then(response => {
            console.log(response);
            this.showAlert('success','Clinica Agregada','Clinica Agregada éxitosamente!');
        }, error => {
            console.error(error);
            this.showAlert('danger','Error al agregar clinica',error.response.data.error);
        });
      
    },
    showAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
  },
  watch: {
    zoomJWT (oldV, newV){
      console.log(oldV,newV);
      if(this.zoomJWT.length >=168){
        this.invalid = false;
      }
    }
  }
}
</script>
